import { createFileRoute } from "@tanstack/react-router";
import { ReportsPage } from "../features/reports/reports-page";
import { validateReportSearch } from "../features/reports/search";
import { Require } from "../features/require";

/** More > Reports (P11-T05), owners and managers. */
export const Route = createFileRoute("/more/reports/")({
	validateSearch: validateReportSearch,
	component: Page,
});

function Page() {
	const search = Route.useSearch();
	return (
		<Require permission="reports.view">
			<ReportsPage initial={search} />
		</Require>
	);
}
